import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {AbstractVisbosComponent} from "../abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'vb-tax-calculator',
  templateUrl: './tax-calculator.component.html',
  styleUrls: ['./tax-calculator.component.css']
})
export class TaxCalculatorComponent extends AbstractVisbosComponent implements OnInit, OnChanges {

  @Input()
  tax: number = 19.0;

  @Input()
  initialValue: number;

  @Input()
  mode: 'BruttoToNetto' | 'NettoToBrutto' = 'NettoToBrutto';

  @Input()
  forceMode: boolean = false;

  private withoutTaxSub: Subscription;
  private withTaxSub: Subscription;

  @Output()
  compute: EventEmitter<{ type: 'Brutto' | 'Netto', value: number }> = new EventEmitter();

  control: FormGroup;

  constructor(sessionActions: SessionActions, private fb: FormBuilder, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

    this.control = this.fb.group({
      tax: [this.tax, Validators.required],
      withTax: [null, Validators.required],
      withoutTax: [null, Validators.required]
    });

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.mode) {
      if (this.mode == 'NettoToBrutto') {
        this.setNettoToBruttoMode();
      }

      if (this.mode == 'BruttoToNetto') {
        this.setBruttoToNettoMode();
      }
    }

    if (changes.tax) {
      this.control.get('tax').setValue(this.tax);
    }

    if (changes.initialValue) {
      if (this.mode == 'NettoToBrutto') {
        this.control.get('withoutTax').setValue(this.initialValue);
      } else {
        this.control.get('withTax').setValue(this.initialValue);
      }
    }
  }

  onSelectMode() {

    this.control.reset({
      withTax: null,
      withoutTax: null,
      tax: this.tax
    });

    if (this.mode == 'BruttoToNetto') {
      this.setNettoToBruttoMode();
    } else {
      this.setBruttoToNettoMode();
    }
  }

  private setNettoToBruttoMode() {
    this.mode = 'NettoToBrutto';

    this.control.get('withTax').disable();
    this.control.get('withoutTax').enable();

    if (this.withTaxSub) {
      this.withTaxSub.unsubscribe();
    }

    this.withoutTaxSub = this.control.get('withoutTax').valueChanges.subscribe(netto => {
      let brutto = this.computeToBrutto(netto);
      this.control.get('withTax').setValue(brutto.toFixed(2));
      this.compute.next({type: 'Brutto', value: brutto});
    });
  }

  private setBruttoToNettoMode() {
    this.mode = 'BruttoToNetto';

    this.control.get('withoutTax').disable();
    this.control.get('withTax').enable();

    if (this.withoutTaxSub) {
      this.withoutTaxSub.unsubscribe();
    }

    this.withTaxSub = this.control.get('withTax').valueChanges.subscribe(brutto => {
      let netto = this.computeToNetto(brutto);
      this.control.get('withoutTax').setValue(netto.toFixed(2));
      this.compute.next({type: 'Netto', value: netto});
    });
  }

  computeToNetto(brutto: number): number {
    return +(brutto / (1 + this.control.get('tax').value / 100));
  }

  computeToBrutto(netto: number): number {
    return +(netto + (netto * this.control.get('tax').value / 100));
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    if (this.withTaxSub) {
      this.withTaxSub.unsubscribe();
    }
    if (this.withoutTaxSub) {
      this.withoutTaxSub.unsubscribe();
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/components/tax-calculator/tax-calculator.component.ts